import Actions from '../actions/actions';
import { whatsNewCRUDActions } from '../actions/WhatsNewCRUDActions';
import { retrievedAllPagination } from './common/commonReducers';
import { WhatsNewModel } from '../model/WhatsNewModel';
import { Pagination } from '../store-interfaces';

export type WhatsNewInitialState = {
  entities: WhatsNewModel[];
  pagination: Pagination | {};
};

const initialState: WhatsNewInitialState = {
  entities: [],
  pagination: {},
};

export const whatsNew = (state = initialState, action: any) => {
  switch (action.type) {
    case whatsNewCRUDActions.retrievedAllAction:
      return retrievedAllPagination(state, action);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
};
